import { Condicion } from "../../../layout/encuestas/encuestas-detalle/editor-condiciones/clases/Condicion";


import { obtenerIdsGenero, TipoCondicionEnum } from "@shared/enums";

export const condiciones = [
    new Condicion(TipoCondicionEnum.PAIS, "Si su pais es...", condicion => condicion.length === 2),
    new Condicion(TipoCondicionEnum.GENERO, "Si su genero es...", condicion =>
        obtenerIdsGenero().map(generosNombres => generosNombres[1].toLowerCase()).includes(condicion.toLowerCase())
    ),
    new Condicion(TipoCondicionEnum.CONTESTO, "Si contesto ...", condicion => /[qi]([0-9])*/.test(condicion)),
    new Condicion(TipoCondicionEnum.TAG, "Si tiene el tag ...", condicion => /t([0-9])*/.test(condicion))
];
